var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviousArrowBox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.9vw",
    height: "1.9vw",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 3.5,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2256 24.5068L18.9375 20.0596L18.7773 19.9248L18.9375 19.7891L24.0459 15.4941L22.5439 14.2305L15.7734 19.9248L22.7236 25.7705L24.2256 24.5068Z",
    fill: "#101010",
    stroke: "#101010",
    strokeWidth: 0.353205
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousArrowBox);
export default __webpack_public_path__ + "static/media/PreviousArrowBox.3de9a48002cb0463b89067a034b64a76.svg";
export { ForwardRef as ReactComponent };